//Karriere Filter

export function initkarrierefilter(){
    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    };

    var filt1List = [];
    var filt2List = [];
    var filt3List = [];

    $(".teaser-karriere > .teaser-karriere-element").each(function () {
        var filt1 = $(this).data("filt1");
        var filt2 = $(this).data("filt2").split(";")[0];
        var filt3 = $(this).data("filt3");
        if (filt1.indexOf(",") !== -1) {
            var filterTokens = filt1.split(" ").join("").split(",");
            for (var x = 0; x < filterTokens.length; x++) {
                if ($.inArray(filterTokens[x], filt1List) === -1 && filterTokens[x] !== "") {
                    filt1List.push(filterTokens[x]);
                }
            }
        }
        else {
            if ($.inArray(filt1, filt1List) === -1 && filt1 !== "") {
                filt1List.push(filt1);
            }
        }
        if ($.inArray(filt2, filt2List) === -1 && filt2 !== "") {
            filt2List.push(filt2);
        }
        if ($.inArray(filt3, filt3List) === -1 && filt3 !== "") {
            filt3List.push(filt3);
        }
    });
    filt1List.sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
    });
    filt3List.sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
    });
    for (var x = 0; x < filt1List.length; x++) {
        $(".filt-1").append("<option value='" + filt1List[x] + "'" + ">" + filt1List[x] + "</option>");
    }
    for (var x = 0; x < filt2List.length; x++) {
        $(".filt-2").append("<option value='" + filt2List[x] + "'" + ">" + filt2List[x] + "</option>");
    }
    for (var x = 0; x < filt3List.length; x++) {
        $(".filt-3").append("<option value='" + filt3List[x] + "'" + ">" + filt3List[x] + "</option>");
    }

    $(".filt-1, .filt-2, .filt-3").on("change", function () {
        var filter1 = $(".filt-1 option:selected").val();
        var filter2 = $(".filt-2 option:selected").val();
        var filter3 = $(".filt-3 option:selected").val();

        /*$(".teaser-karriere-element a").each(function(){
          $(this).attr("href",$(this).attr("href").split("?")[0]);
        });*/



        var rememberFilters = ["filt-1=" + filter1, "filt-2=" + filter2, "filt-3=" + filter3].join("&");

        $(".teaser-karriere-element a").each(function () {
            $(this).attr("href", $(this).attr("href").replace(/filt-1.*filt-3=.*?(&|$)/, ""));
            if ($(this).attr("href").indexOf("?") !== -1) { //Query-String bereits vorhanden
                if (!$(this).attr("href").endsWith("&")) {
                    $(this).attr("href", $(this).attr("href") + "&" + rememberFilters);
                }
                else {
                    $(this).attr("href", $(this).attr("href") + rememberFilters);
                }
            }
            else {
                $(this).attr("href", $(this).attr("href") + "?" + rememberFilters);
            }
        });


        $(".teaser-karriere > .teaser-karriere-element").each(function () {
            if ($(this).data("filt1").indexOf(filter1) !== -1 && $(this).data("filt2").indexOf(filter2) !== -1 && $(this).data("filt3").indexOf(filter3) !== -1) {
                $(this).show();
            }
            else {
                $(this).hide();
            }
        });
    });

    $("select.filt-1").val(getUrlParameter("filt-1"));
    $("select.filt-2").val(getUrlParameter("filt-2"));
    $("select.filt-3").val(getUrlParameter("filt-3"));

    $("select.filt-1").trigger("change");
    $("select.filt-2").trigger("change");
    $("select.filt-3").trigger("change");
}

